/**
 * The offer the next message accepts. Juneau sends text only, so the nudge card arms it here
 * and the very next turn goes out in NUDGE mode; the server re-checks the offer either way.
 */
let armedNudgeId: string | null = null;

/** Makes the next sent message accept this offer. */
export function armNudge(nudgeId: string): void {
  armedNudgeId = nudgeId;
}

/** Takes the armed offer, once. */
export function takeArmedNudge(): string | null {
  const nudgeId = armedNudgeId;
  armedNudgeId = null;
  return nudgeId;
}
